<template>
  <a-space>
    <a-button
      :loading="loading"
      :disabled="selectedIds.length === 0"
      type="primary"
      @click="onRecover"
      v-perm="recycleBinConfig.recoverPremKey"
      >恢复</a-button
    >
    <a-button
      :loading="loading"
      :disabled="selectedIds.length === 0"
      type="primary"
      danger
      @click="onDelete"
      v-perm="recycleBinConfig.deletePremKey"
      >彻底删除</a-button
    >
  </a-space>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import { message } from "ant-design-vue";
import _ from "lodash";
import { useFlowHandle } from "../table-flow-btn/useFlowHandle";
export default defineComponent({
  isGlobal: true,
  name: "RecycleBinBtn",
  props: {
    selectedIds: {
      type: Array,
      default: () => [],
    },
    api: {
      type: String,
    },
    queryRef: {
      type: Object,
      default: () => {
        return {};
      },
    },
    recycleBinConfig: {
      type: Object,
      default: () => {
        return {};
      },
    },
    btnType: {
      type: String,
      default: "",
    },
  },
  emits: ["refresh"],
  setup(props, { emit }) {
    let loading = ref(false);
    const { deleteCompleteBtn } = useFlowHandle();
    const onDelete = async () => {
      if (!props.selectedIds || !props.selectedIds.length) {
        message.warning("请先选择要删除的内容");
        return;
      }
      try {
        loading.value = true;
        // const { run } = ExportBtnService.useExportApi();
        // let params = _.cloneDeep(props.queryRef);
        // params.ids = props.selectedIds;
        let res = await deleteCompleteBtn(props.selectedIds, props.btnType);
        emit("refresh");
      } finally {
        loading.value = false;
      }
    };
    const onRecover = async () => {
      if (!props.selectedIds || !props.selectedIds.length) {
        // console.log(props);
        message.warning("请先选择要恢复的内容");
        return;
      }
      emit("refresh");

      try {
        loading.value = true;
        // const { run } = ExportBtnService.useExportApi();
        // let params = _.cloneDeep(props.queryRef);
        // params.ids = props.selectedIds;
        // let res = await run(props.api, params);
        // if (res.respCode !== "0000") {
        //   message.error(res.respDesc);
        //   return;
        // }
        // message.success(res.respDesc);
        // if (res.data && res.data.url) {
        //   window.open(res.data.url);
        // }
      } finally {
        loading.value = false;
      }
    };
    return {
      onRecover,
      loading,
      onDelete,
    };
  },
});
</script>

<style scoped>
.ant-btn-primary[disabled],
.ant-btn-primary[disabled]:hover,
.ant-btn-primary[disabled]:focus,
.ant-btn-primary[disabled]:active {
  color: #fff;
  border-color: #579aff;
  background: #579aff;
}
.ant-btn-dangerous[disabled],
.ant-btn-dangerous[disabled]:hover,
.ant-btn-dangerous[disabled]:focus,
.ant-btn-dangerous[disabled]:active {
  color: #fff;
  border-color: #ff7875 !important;
  background-color: #ff7875 !important;
}
</style>
